import styled from '@emotion/styled'
import { spacer } from 'stylist'

const FormDescription = styled.p`
  margin-bottom: ${spacer(5)};
`

export default FormDescription



// WEBPACK FOOTER //
// ./src/components/FormDescription.js